import { useEffect } from "react";

export const KBD_HEIGHT_KEY = "--kbd-height";
export const VISUAL_VIEWPORT_HEIGHT_KEY = "--visual-viewport-height";
export const MODAL_FOOTER_PADDING_KEY = "--modal-footer-padding";

export const useVisualViewportCalculate = () => {
  useEffect(() => {
    document.documentElement.style.setProperty(KBD_HEIGHT_KEY, "0px");
    document.documentElement.style.setProperty(
      VISUAL_VIEWPORT_HEIGHT_KEY,
      `${window.innerHeight}px`
    );
    document.documentElement.style.setProperty(
      MODAL_FOOTER_PADDING_KEY,
      "env(safe-area-inset-bottom)"
    );

    const handleResize = () => {
      const visualViewport = window.visualViewport;
      if (!visualViewport) return;

      // 가상 키보드가 열리면 viewport 높이가 줄어듦
      const isKeyboardOpen = visualViewport.height < window.innerHeight;

      if (isKeyboardOpen) {
        document.documentElement.style.setProperty(
          KBD_HEIGHT_KEY,
          `${window.innerHeight - visualViewport.height}px`
        );
        document.documentElement.style.setProperty(
          VISUAL_VIEWPORT_HEIGHT_KEY,
          `${visualViewport.height}px`
        );
        document.documentElement.style.setProperty(
          MODAL_FOOTER_PADDING_KEY,
          "0px"
        );
      } else {
        document.documentElement.style.setProperty(KBD_HEIGHT_KEY, "0px");
        document.documentElement.style.setProperty(
          VISUAL_VIEWPORT_HEIGHT_KEY,
          `${window.innerHeight}px`
        );
        document.documentElement.style.setProperty(
          MODAL_FOOTER_PADDING_KEY,
          "env(safe-area-inset-bottom)"
        );
      }
    };

    window.visualViewport?.addEventListener("resize", handleResize);
    return () => {
      window.visualViewport?.removeEventListener("resize", handleResize);
    };
  }, []);
};
